import script from "./VerifyEmailView.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifyEmailView.vue?vue&type=script&setup=true&lang=js"

import "./VerifyEmailView.vue?vue&type=style&index=0&id=73838d50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73838d50"]])

export default __exports__